import * as React from 'react';
import * as styles from './FoldersNotification.css';

interface IFoldersNotificationProps {
  children: React.ReactNode;
}

export function FoldersNotification({ children }: IFoldersNotificationProps) {
  return <div className={styles['container']}>{children}</div>;
}
